// react
import { ReactNode, useContext, useState } from 'react';

// types
import { Entity } from '../../../@types';

// context
import { ContextUser, ContextUserEntity } from '../../../App.context';

// mui
import { SelectChangeEvent } from '@mui/material';

// fields
import { Select } from '../Select/Select';
import { ContextProject } from '../../pages/Project/Project.context';

export const SelectUserEntity = () => {
	// context
	const { project } = useContext(ContextProject);
	const { user } = useContext(ContextUser);
	const { userEntity, setUserEntity } = useContext(ContextUserEntity);

	// defaults
	let entities = (user?.entities as Entity[]) || [];
	let defaultEntity = String(userEntity?.id || '');

	if (project?.id) {
		// filter entities by project
		entities = (user?.entities as Entity[]).filter((entity) =>
			Boolean((entity.projects as number[])?.find((id) => id === project.id))
		);

		// find default entity in project entities
		const userEntityFound = entities.find((e) => String(e.id) === defaultEntity);

		// set first project entity as default if default entity is not found in project entities
		if (!userEntityFound && entities.length) {
			defaultEntity = String(entities[0]?.id || '');
		}
	}

	// state
	const [entity, setEntity] = useState(defaultEntity);

	const handleChangeEntity = (e: SelectChangeEvent<unknown>, child: ReactNode) => {
		const { value } = e.target as HTMLInputElement;
		const entity = (user?.entities as Entity[]).find((entity) => String(entity.id) === value);

		setEntity(value);

		if (entity) {
			sessionStorage.setItem('userEntityId', String(entity.id));
			setUserEntity(entity);
		}
	};

	const optionsEntities = entities.map((entity) => {
		return {
			label: entity.name,
			value: String(entity.id),
		};
	});

	return (
		<Select
			hasNoneOption={false}
			onChange={handleChangeEntity}
			options={optionsEntities}
			value={entity}
		/>
	);
};
